import { HardDrive, AlertTriangle } from "lucide-react";
import { Section } from "@/components/common";

const GB = 1024 ** 3;

export function StorageUsage({ storage }) {
  const used = storage?.used_bytes || 0;
  const limit = storage?.limit_gb;
  const pct = limit ? Math.min(100, (used / (limit * GB)) * 100) : 0;
  const state = pct >= 100 ? "full" : pct >= 80 ? "warning" : "ok";
  const bar = { full: "bg-rose-500", warning: "bg-amber-500", ok: "bg-emerald-500" }[state];
  return (
    <Section title={<span className="inline-flex items-center gap-2"><HardDrive className="h-4 w-4" />File storage</span>} testId="storage-usage">
      <div className="space-y-3 p-5" data-state={state}>
        <div className="flex flex-wrap justify-between gap-2 text-sm">
          <span className="font-medium text-slate-900" data-testid="storage-usage-used">{(used / GB).toFixed(2)} GB used</span>
          <span className="text-slate-500" data-testid="storage-usage-total">of {limit ?? "—"} GB · {pct.toFixed(1)}%</span>
        </div>
        <div className="h-2.5 rounded-full bg-slate-100" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100}>
          <div className={`h-2.5 rounded-full transition-[width] duration-500 ${bar}`} style={{ width: `${pct}%` }} data-testid="storage-usage-bar" />
        </div>
        {state !== "ok" && (
          <p className={`flex items-start gap-2 text-sm ${state === "full" ? "text-rose-700" : "text-amber-700"}`} data-testid="storage-usage-warning">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            {state === "full" ? "Storage is full. New uploads are blocked until you delete old files or your limit is increased."
              : "You've used over 80% of your storage. Delete old files or contact your platform administrator to add storage."}
          </p>
        )}
        <p className="text-xs text-slate-500">Counts artwork and proof files uploaded to this workspace.</p>
      </div>
    </Section>
  );
}
